export enum PaymentSource {
    MOBILE = 'MOBILE',
    PORTAL = 'PORTAL',
    FLEET = 'FLEET',
    FLEET_REGISTRATION = 'FLEET_REGISTRATION'
}
